module.exports = __webpack_public_path__ + "img/gend.dac157c2.svg";